// extracted by extract-css-chunks-webpack-plugin
module.exports = {"heading":"app-components-interestform-slides-artists-artists--heading","artistsImageWrapper":"app-components-interestform-slides-artists-artists--artistsImageWrapper"};